// extracted by mini-css-extract-plugin
module.exports = {"catalogSearchBar":"cardCategory_catalogSearchBar__2HtMy","catalogSearchField":"cardCategory_catalogSearchField__2pA4Y","catalogSearchTags":"cardCategory_catalogSearchTags__LABjC"};